import { create } from "zustand";

interface EditorState {
  setContent?: (content: string | null) => void;
  setSetContent: (setContent: ((content: string | null) => void) | undefined) => void;

  commentsUpdated?: () => void;
  setCommentsUpdated: (commentsUpdated?: () => void) => void;

  imgsCropUpdated?: () => void;
  setImgsCropUpdated: (imgsCropUpdated?: () => void) => void;

  getMarkdown?: () => string | null;
  setGetMarkdown: (getMarkdown: (() => string | null) | undefined) => void;

  getHtml?: () => string | null;
  setGetHtml: (getHtml: (() => string | null) | undefined) => void;

  pasteContent?: (content: string) => void;
  setPasteContent: (pasteContent: ((content: string) => void) | undefined) => void;

  highlightText?: (text: string) => void;
  setHighlightText: (highlightText: ((text: string) => void) | undefined) => void;

  highlightTableRow?: (originalRow: string, cleanText: string) => void;
  setHighlightTableRow: (highlightTableRow: ((originalRow: string, cleanText: string) => void) | undefined) => void;

  removeCommentMark?: (commentId: string) => void;
  setRemoveCommentMark: (removeCommentMark: ((commentId: string) => void) | undefined) => void;

  flushSave?: () => Promise<void>;
  setFlushSave: (flushSave: (() => Promise<void>) | undefined) => void;
}

// Editor store is only concerned with providing direct access to the tiptap editor
export const useEditorStore = create<EditorState>((set) => ({
  setSetContent: (setContent) => {
    set({ setContent });
  },
  setCommentsUpdated: (commentsUpdated) => {
    set({ commentsUpdated });
  },
  setImgsCropUpdated: (imgsCropUpdated) => {
    set({ imgsCropUpdated });
  },
  setGetMarkdown: (getMarkdown) => {
    set({ getMarkdown });
  },
  setGetHtml: (getHtml) => {
    set({ getHtml });
  },
  setPasteContent: (pasteContent) => {
    set({ pasteContent });
  },
  setHighlightText: (highlightText) => {
    set({ highlightText });
  },
  setHighlightTableRow: (highlightTableRow) => {
    set({ highlightTableRow });
  },
  setRemoveCommentMark: (removeCommentMark) => {
    set({ removeCommentMark });
  },
  setFlushSave: (flushSave) => {
    set({ flushSave });
  }
}));
